export enum TimeMagnitude {
  Seconds = 10,
  MilliSeconds = 13,
  MicroSeconds = 16,
  NanoSeconds = 19,
}
